export default "__VITE_ASSET__ef5e00d9__"